import { mdiCropFree } from '@lumapps/lumx/icons';

export const WIDGET_IFRAME_TYPE = 'iframe';

export const WIDGET_IFRAME_ICON = mdiCropFree;
export const WIDGET_IFRAME_EDITION_SCOPE = 'widget-iframe-edition';
